
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { Row, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { Balances, ProjectedBalances } from '@/modules/trade/services/account';

@Component({
  components: {
    Row,
    BackButton,
    BaseText
  }
})
export default class LiquidateNextDays extends Vue {
  @Prop({ type: Object, required: true })
  readonly balances!: Balances;

  @Emit('set-available')
  public emitSetAvailable() {}

  @Emit('set-composition')
  public emitSetComposition(projectedBalances: ProjectedBalances) {
    return projectedBalances;
  }

  readonly NebraskaColors = NebraskaColors;

  public get toLiquidateBalance() {
    return this.balances.toLiquidateBalance?.formatted;
  }
}
